"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

require("./Button.css");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

var _core = require("@material-ui/core");

var _excluded = ["disabled", "loading", "size", "color", "type", "onClick", "children", "fullWidth", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @visibleName Button
 */
function Button(_ref) {
  var disabled = _ref.disabled,
      loading = _ref.loading,
      size = _ref.size,
      color = _ref.color,
      type = _ref.type,
      onClick = _ref.onClick,
      children = _ref.children,
      fullWidth = _ref.fullWidth,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var handleClick = (0, _core.debounce)(onClick, 200);
  var styles = {
    width: 'auto'
  };

  if (fullWidth) {
    styles.width = '100%';
  }

  var classNames = 'btn btn-fill';

  if (color === 'secondary') {
    classNames += ' secondary';
  } else if (color === 'tertiary') {
    classNames += ' tertiary';
  }

  if (size === 'small') {
    classNames += ' small';
  } else if (size === 'extra-small') {
    classNames += ' extra-small';
  }

  if (loading) {
    classNames += ' loading';
    var iconColor = '#fff';

    if (color === 'secondary' || color === 'tertiary') {
      iconColor = _Colors.default.sinineVaal;
    }

    return /*#__PURE__*/_react.default.createElement("button", _extends({
      className: "".concat(classNames, " ").concat(className),
      style: styles,
      onClick: handleClick,
      disabled: disabled
    }, rest), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "loading",
      color: iconColor,
      margin: "auto 10px auto auto"
    }), children);
  }

  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: type,
    className: "".concat(classNames, " ").concat(className),
    style: styles,
    onClick: handleClick,
    disabled: disabled
  }, rest), children);
}

Button.propTypes = {
  /** Button label */
  children: _propTypes.default.node.isRequired,

  /** The type of the button */
  type: _propTypes.default.oneOf(['button', 'reset', 'submit']),

  /** Color of the button */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),

  /** The size of the button */
  size: _propTypes.default.oneOf(['normal', 'small', 'extra-small']),

  /** Disable button */
  disabled: _propTypes.default.bool,

  /** Loading button */
  loading: _propTypes.default.bool,

  /** Gets called when the user clicks on the button */
  onClick: _propTypes.default.func,

  /** The width of the button */
  fullWidth: _propTypes.default.bool
};
Button.defaultProps = {
  type: 'button',
  color: 'primary',
  loading: false,
  size: 'normal',
  fullWidth: false,
  onClick: function onClick(event) {
    // eslint-disable-next-line no-console
    console.log('You have clicked me!', event.target);
  }
};
var _default = Button;
exports.default = _default;